export const ADVICE_CATEGORIES = [
  {
    slug: "life-coaching",
    title: "Life Coaching Advice Online",
    seoTitle: "Life Coaching Advice Online | Instant Calls with Certified Coaches",
    description:
      "Get life coaching advice online through instant audio or video calls with verified coaches on Camyvera. Talk through clarity, goals, confidence, and next steps fast.",
    hero:
      "Talk to a life coach when timing matters. Get fast guidance on clarity, confidence, habits, and personal decisions without waiting weeks for an appointment.",
    keywords:
      "life coaching advice online, talk to a life coach, instant life coach, pay per minute life coaching, life coach call",
    primaryLinks: [
      { href: "/talk-to-life-coach", label: "Talk to a Life Coach" },
      { href: "/instant-coaching-call", label: "Instant Coaching Call" },
      { href: "/blog/how-to-talk-to-experts-online", label: "Read the Expert Advice Guide" },
    ],
    faqs: [
      {
        q: "Can I talk to a life coach right away?",
        a: "Yes. Camyvera is designed for instant coaching calls, so if a coach is online you can connect immediately by audio or video.",
      },
      {
        q: "Is life coaching billed monthly?",
        a: "No. On Camyvera you pay per minute for the time you use, which is often a better fit for short, decision-focused coaching calls.",
      },
      {
        q: "What topics can I bring to a life coach?",
        a: "People commonly use life coaching calls for clarity, confidence, goal-setting, habits, transitions, and making hard personal decisions.",
      },
    ],
  },
  {
    slug: "business-advice",
    title: "Business Advice Online",
    seoTitle: "Business Advice Online | Instant Calls with Coaches and Operators",
    description:
      "Get business advice online from verified mavens on Camyvera. Talk through pricing, growth, hiring, GTM, and operator decisions through instant paid calls.",
    hero:
      "Need a second brain on pricing, growth, hiring, or execution? Talk to business coaches and operators in real time instead of waiting for a future meeting.",
    keywords:
      "business advice online, business coach call, startup mentor advice, founder advice online, pay per minute business consulting",
    primaryLinks: [
      { href: "/talk-to-business-coach", label: "Talk to a Business Coach" },
      { href: "/talk-to-startup-mentor", label: "Talk to a Startup Mentor" },
      { href: "/blog/best-platforms-for-paid-calls", label: "Compare Paid Call Platforms" },
    ],
    faqs: [
      {
        q: "What kind of business advice can I get online?",
        a: "Common use cases include pricing, hiring, go-to-market, founder decision-making, customer acquisition, and operator feedback.",
      },
      {
        q: "Why use pay-per-minute business consulting?",
        a: "It lets you get targeted advice for a specific decision without committing to a large retainer or a full consulting engagement.",
      },
      {
        q: "Can I talk to a startup mentor and a business coach on Camyvera?",
        a: "Yes. Camyvera supports both general business coaching and startup-specific mentoring depending on the profile you choose.",
      },
    ],
  },
  {
    slug: "career-advice",
    title: "Career Advice Online",
    seoTitle: "Career Advice Online | Talk to a Career Coach Fast",
    description:
      "Get career advice online with instant calls on Camyvera. Talk through interviews, promotions, offers, salary negotiation, and job search strategy with a live coach.",
    hero:
      "When an interview, offer, or promotion decision is time-sensitive, a live career coach can help you move faster with more confidence.",
    keywords:
      "career advice online, talk to a career coach, instant career coaching, salary negotiation coach, interview coaching online",
    primaryLinks: [
      { href: "/talk-to-career-coach", label: "Talk to a Career Coach" },
      { href: "/guides", label: "Browse Camyvera Guides" },
      { href: "/blog/best-way-to-get-maven-advice-online", label: "Read the 2026 Advice Guide" },
    ],
    faqs: [
      {
        q: "Can I use Camyvera for interview coaching?",
        a: "Yes. Many seekers use Camyvera for live interview prep, job search decisions, salary negotiation, and offer evaluation.",
      },
      {
        q: "How quickly can I talk to a career coach?",
        a: "If a coach is online, you can usually start an instant call within seconds instead of scheduling days in advance.",
      },
      {
        q: "Do I need to buy a package?",
        a: "No. Camyvera uses pay-per-minute calls so you can get targeted help without buying a larger coaching package.",
      },
    ],
  },
  {
    slug: "relationship-advice",
    title: "Relationship Advice Online",
    seoTitle: "Relationship Advice Online | Instant Calls with Relationship Coaches",
    description:
      "Get relationship advice online on Camyvera through instant calls with verified coaches. Talk through communication, boundaries, conflict, dating, and hard conversations.",
    hero:
      "Sometimes you need perspective before the next text, date, or conversation. Camyvera helps you talk to a relationship coach immediately.",
    keywords:
      "relationship advice online, talk to a relationship coach, dating coach online, instant relationship coaching, coaching call for relationships",
    primaryLinks: [
      { href: "/talk-to-relationship-coach", label: "Talk to a Relationship Coach" },
      { href: "/talk-to-dating-coach", label: "Talk to a Dating Coach" },
      { href: "/pay-per-minute-consultation", label: "Why Pay-Per-Minute Works" },
    ],
    faqs: [
      {
        q: "What relationship topics are a good fit for instant coaching?",
        a: "People often use relationship coaching calls for conflict, communication, boundaries, difficult conversations, and clarity about next steps.",
      },
      {
        q: "Can I get help before a difficult conversation?",
        a: "Yes. That is one of the strongest use cases for instant relationship advice because timing often matters more than a future appointment.",
      },
      {
        q: "Is dating advice different from relationship coaching?",
        a: "Usually yes. Dating advice tends to focus on texting, dates, and app strategy, while relationship coaching focuses more on ongoing dynamics and communication.",
      },
    ],
  },
  {
    slug: "startup-advice",
    title: "Startup Advice Online",
    seoTitle: "Startup Advice Online | Instant Founder and Operator Mentorship",
    description:
      "Get startup advice online through live calls with founders, operators, and startup mentors on Camyvera. Talk through GTM, fundraising, pricing, and hiring decisions.",
    hero:
      "Founders often need sharp input today, not next month. Use Camyvera for real-time startup advice from people who have been through it.",
    keywords:
      "startup advice online, startup mentor call, founder advice, GTM advice online, fundraising mentor",
    primaryLinks: [
      { href: "/talk-to-startup-mentor", label: "Talk to a Startup Mentor" },
      { href: "/video-consultation-platform", label: "See the Consultation Platform" },
      { href: "/blog/how-to-monetize-knowledge-as-coach", label: "For Mavens: Monetize Knowledge" },
    ],
    faqs: [
      {
        q: "What startup decisions are a good fit for a short mentor call?",
        a: "Founders often use short calls for pricing, GTM, fundraising messaging, hiring decisions, positioning, and product tradeoffs.",
      },
      {
        q: "Why use instant startup advice instead of scheduling a mentor later?",
        a: "Because many founder decisions are time-sensitive. Instant advice helps you move while the context is still fresh.",
      },
      {
        q: "Can I talk to people with operator experience?",
        a: "Yes. Camyvera profiles can include operators, founders, coaches, and niche experts with specific functional expertise.",
      },
    ],
  },
  {
    slug: "dating-advice",
    title: "Dating Advice Online",
    seoTitle: "Dating Advice Online | Instant Calls with Dating Coaches",
    description:
      "Get dating advice online from live coaches on Camyvera. Talk through texting, first dates, confidence, dating apps, and decision-making through instant calls.",
    hero:
      "Get fast, practical help with texting, first dates, confidence, or dating app strategy through real-time coaching on Camyvera.",
    keywords:
      "dating advice online, talk to a dating coach, instant dating advice, dating coach call, relationship advice online",
    primaryLinks: [
      { href: "/talk-to-dating-coach", label: "Talk to a Dating Coach" },
      { href: "/relationship-advice", label: "Explore Relationship Advice" },
      { href: "/talk-to-experts-online", label: "How Camyvera Works" },
    ],
    faqs: [
      {
        q: "Can I get help with dating apps and texting?",
        a: "Yes. Dating coaching on Camyvera is commonly used for texting decisions, dating app strategy, confidence, and first-date feedback.",
      },
      {
        q: "Do I need a long coaching package for dating advice?",
        a: "No. Camyvera is designed for short, targeted, pay-per-minute calls when you need perspective quickly.",
      },
      {
        q: "How fast can I connect to a dating coach?",
        a: "If a coach is currently online, you can usually connect immediately without waiting for a scheduled session.",
      },
    ],
  },
];

export const ADVICE_CATEGORY_ROUTE_MAP = ADVICE_CATEGORIES.map((category) => ({
  path: `/${category.slug}`,
  changefreq: "weekly",
  priority: 0.85,
}));
